"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var profile_scss_1 = __importDefault(require("./profile.scss"));
var Profile = (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            time: Date.now(),
            count: 10
        };
        _this.updateTime = function () {
            _this.setState({ time: Date.now() });
        };
        _this.increment = function () {
            _this.setState({ count: _this.state.count + 1 });
        };
        return _this;
    }
    Profile.prototype.componentDidMount = function () {
        this.timer = setInterval(this.updateTime, 1000);
    };
    Profile.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    Profile.prototype.render = function (_a, _b) {
        var _c = _a.user, user = _c === void 0 ? 'null' : _c;
        var time = _b.time, count = _b.count;
        return (preact_1.h("div", { class: profile_scss_1.default.profile },
            preact_1.h("h1", null,
                "Profile: ",
                user),
            preact_1.h("p", null,
                "This is the user profile for a user named ",
                user,
                "."),
            preact_1.h("div", null,
                "Current time: ",
                new Date(time).toLocaleString()),
            preact_1.h("p", null,
                preact_1.h("button", { onClick: this.increment }, "Click Me"),
                " Clicked ",
                count,
                " times.")));
    };
    return Profile;
}(preact_1.Component));
exports.default = Profile;
//# sourceMappingURL=profile.js.map


// WEBPACK FOOTER //
// ./routes/profile/profile.js